import en from './en'
import es from './es'
import enUK from './en-uk'
import fr from './fr'
import ru from './ru'
import ar from './ar'

export default { en, 'en-uk': enUK, es, fr, ru, ar }
